import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SlotShape from '../../../../../../../shapes/Slot';
import DateTime, { HOUR_MINUTE_PERIOD } from '../../../../../../DateTime/DateTime';
import TimeSlot from './TimeSlot';
import { emptyFunction } from '../../../../../../../core/util/function';

class Slot extends PureComponent {
  selectSlot = () => {
    this.props.onSelect(this.props.slot);
  };

  render() {
    const { timeZone, slot, isSelected, className, showBusyTooltip, darkTheme } = this.props;
    const { availability, isBusy } = slot;
    const time = DateTime.format(slot.appointmentDate, timeZone)(HOUR_MINUTE_PERIOD);

    return (
      <TimeSlot
        className={className}
        time={time}
        isAvailable={availability > 0}
        darkTheme={darkTheme}
        shouldShowSlotAsBusy={isBusy}
        isSelected={isSelected}
        onSelect={this.selectSlot}
        showBusyTooltip={showBusyTooltip}
      />
    );
  }
}

Slot.propTypes = {
  slot: SlotShape,
  timeZone: PropTypes.string,
  darkTheme: PropTypes.bool,
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  onSelect: PropTypes.func,
  showBusyTooltip: PropTypes.bool,
};

Slot.defaultProps = {
  onSelect: emptyFunction,
};

export default Slot;
